export default __webpack_public_path__ + "static/media/icon-dollar.74d1225b.svg";